var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("group-page-header", { attrs: { title: "Shared Stories" } }, [
        _c(
          "span",
          { attrs: { slot: "additionalButtons" }, slot: "additionalButtons" },
          [
            _vm.viewer_state.is_admin
              ? _c("toggle-edit-mode-button", {
                  model: {
                    value: _vm.editMode,
                    callback: function ($$v) {
                      _vm.editMode = $$v
                    },
                    expression: "editMode",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "shared-list__container" },
        [
          _vm._l(_vm.results, function (story) {
            return _c("rectangle-stuff-preview", {
              key: story.id,
              attrs: {
                to: _vm._f("backHref")(story.link),
                name: story.name,
                avatar: story.avatar,
                "media-content-samples": story.media_content_samples,
                "color-class": "story",
                "prefer-avatar": true,
                "super-avatar": story.userprofile
                  ? story.userprofile.avatar
                  : undefined,
                "unread-mark": story.is_unread,
                deletable: _vm.editMode,
                size: _vm.previewSize,
              },
              on: {
                delete: function ($event) {
                  return _vm.unShareStory(story.id)
                },
              },
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.swamGetFakeItems(_vm.results.length), function (fakeItem) {
            return _c("div", { key: fakeItem.id, style: _vm.swamFakeIconStyle })
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.initialized && !_vm.results.length
        ? _c("div", { staticClass: "alert alert-info margin-15-top" }, [
            _vm._v(
              "There are not any Stories shared\n        with this Group yet.\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "infinite-scroll",
            rawName: "v-infinite-scroll",
            value: _vm.loadMore,
            expression: "loadMore",
          },
        ],
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }